import { canShowPdf, PdfPages } from '../components/Pdf';
import { Dialog } from '../components/Dialog';
import { t } from '../i18n';

// PDF ansehen (Rechnung oder Vorschau): am PC im Browser, am Handy als Seitenbilder. onMail: Knopf „Per E-Mail“
// (Versand, VersandDialog.tsx); onPost: Knopf „Per Post versenden“ (PostDialog.tsx); onDownload: beim Herunterladen
// (Rechnungsliste: zählt als verschickt); hinweis: graue Zeile über den Knöpfen (Angebote, Aufträge: wann und an wen
// verschickt, versandText)
export function PdfDialog({
  url,
  title,
  download,
  onClose,
  onMail,
  onPost,
  onDownload,
  hinweis,
}: {
  url: string | null;
  title: string;
  download?: string;
  onClose(): void;
  onMail?(): void;
  onPost?(): void;
  onDownload?(): void;
  hinweis?: string | null;
}) {
  const none = <p className="muted">Die PDF kann hier nicht angezeigt werden. Bitte herunterladen.</p>;
  return (
    <Dialog open={!!url} onClose={onClose} title={title} className="rt-pdf">
      {url && (
        <>
          <div className="rt-pdf-b">
            {canShowPdf() ? (
              <object data={url} type="application/pdf" aria-label={title}>
                {none}
              </object>
            ) : (
              <PdfPages url={url} title={title} fallback={none} />
            )}
          </div>
          {hinweis && <p className="rt-pdf-hinweis">{hinweis}</p>}
          <div className="dlg-actions">
            {onMail && (
              <button type="button" className="btn" onClick={onMail}>
                Per E-Mail
              </button>
            )}
            {onPost && (
              <button type="button" className="btn" onClick={onPost}>
                {t('Per Post versenden')}
              </button>
            )}
            {download && (
              <a className="btn" href={download} onClick={onDownload}>
                Herunterladen
              </a>
            )}
            <button type="button" className="btn primary" onClick={onClose}>
              Schließen
            </button>
          </div>
        </>
      )}
    </Dialog>
  );
}
